import { render, staticRenderFns } from "./DeliveryBillDetailList.vue?vue&type=template&id=5afd250c&"
import script from "./DeliveryBillDetailList.vue?vue&type=script&lang=js&"
export * from "./DeliveryBillDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports